module.exports = __webpack_public_path__ + "static/media/ibLogo.4a608e20.png";